import { AppConfigJsonTurno } from '../conf/DeviceConfiguration';

export type GestionBolsaCambioMode = '0' | '1' | '2';

export function resolveGestionBolsaCambio(
  turnoConfig?: AppConfigJsonTurno | null
): GestionBolsaCambioMode {
  const raw = turnoConfig?.GestionBolsaCambio;
  if (raw === '1' || raw === '2') {
    return raw;
  }
  return '0';
}

export function debeMostrarBolsaCambio(mode: GestionBolsaCambioMode): boolean {
  return mode === '1' || mode === '2';
}

export function esBolsaCambioObligatoria(mode: GestionBolsaCambioMode): boolean {
  return mode === '2';
}

export function normalizeBolsaCambio(value?: string | null): string {
  return (value || '').trim();
}

export function isBolsaCambioValidForSubmit(
  mode: GestionBolsaCambioMode,
  value?: string | null
): boolean {
  if (!esBolsaCambioObligatoria(mode)) {
    return true;
  }
  return normalizeBolsaCambio(value).length > 0;
}
